import { useEffect, useState } from "react";
import {
    api, getEventById, getSeatMapById, getZonesBySeatMapId, getRowsByZoneId, getSeatsOfZone, getTicketTypeNumberOfAvailableTickets,
    getTicketTypesByEventId, getTicketTypePriceForOrder, getTicketTypeInfosByTicketTypeId, getEventInfosByEventId
} from "ticketino-api-client";
import axios from 'axios';

import Loading from "./Loading";
import Zone from './Seatmap/Zone';

const SeatmapTicketSelect = (props) => {

    //----variables----

    //developement env dependent
    const baseUrl = process.env.REACT_APP_BASE_TICKETINO_URL;
    const baseProxyUrl = process.env.REACT_APP_PLUGIN_PROXY;

    //prop values
    const selectedEventId = props.eventId;
    const selectedSeatmapId = props.selectedSeatmapId;
    const selectedLanguageId = props.languageCode;
    const changeLanguage = props.changeLanguage;
    const selectedLanguage = props.languageISO;
    const currency = props.selectedCurrency ?? "CHF";
    const token = props.token;
    const orderId = props.orderId;
    const allowUnlockTicketTypes = props.allowUnlockTicketTypes;
    const showEventBanner = props.showEventBanner;
    const enableTickets = props.enableTickets ?? "";
    const selectedEventGroupId = props.eventGroupId;

    const [orderIdParameter, setOrderIdParameter] = useState(0);
    const [loading, setLoading] = useState(true);
    const [resources, setResources] = useState([]);
    const [errorMessage, setErrorMessage] = useState();
    const [seatmap, setSeatmap] = useState({});
    const [zones, setZones] = useState({});
    const [selectedZone, setSelectedZone] = useState({});
    const [promotionCode, setPromotionCode] = useState(""); //promotion code
    const [promotionCodeMessage, setPromotionCodeMessage] = useState("");
    const [isPromotionCodeAdded, setIsPromotionCodeAdded] = useState(false);
    const [event, setEvent] = useState({});
    const [ticketTypes, setTicketTypes] = useState([]);
    const [unlockedTicketTypes, setUnlockedTicketTypes] = useState([]);
    const [isTicketsAvailable, setIsTicketsAvailable] = useState(false);
    const [selectedSeats, setSelectedSeats] = useState([]);

    useEffect(() => {
        requestResources(selectedLanguage);
    }, [selectedLanguage]);

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;
        api.defaults.baseURL = baseUrl;

        if (orderId === 0) {
            startOrder();
        } else {
            loadEvent(selectedEventId, orderId);
            requestSeatmapAndZones();
            //loadEvent(selectedEventId, orderId);
        }

        if (orderId > 0) {
            setOrderIdParameter(orderId);
        }

    }, [orderId]);


    useEffect(() => {
        loadEvent(selectedEventId, orderIdParameter);
    }, [isPromotionCodeAdded])

    const onSeatClick = (event, seat, alreadySelected) => {

        if (alreadySelected) {

            var selectedSeatList = selectedSeats.filter(s => s.id !== seat.id);
            setSelectedSeats(selectedSeatList);
        }
        else {
            const isAlreadyInList = selectedSeats.some(s => s.id === seat.id);
            if (!isAlreadyInList) {

                let selectedSeatList = [...selectedSeats, seat];
                setSelectedSeats(selectedSeatList);               
            }
        }
    }

    //change the user selected langauge
    const updateLanguage = (language) => {
        requestResources(language);
        changeLanguage(language)
    }

    //request resources
    const requestResources = async (langauge) => {
        await axios
            .get(`${baseProxyUrl}/resources/${langauge}`)
            .then((res) => {
                setResources(res.data);
            })
            .catch((error) => console.error(error.response.data));
    };

    const startOrder = async () => {
        let currencyForBody = currency.toUpperCase();

        if (!(currencyForBody == "CHF" || currencyForBody == "EUR" || currencyForBody == "USD" || currencyForBody == "GBP")) {
            currencyForBody = "CHF";
        }

        let startOrderBody = {
            currency: currencyForBody,
            tenantId: 1,
            pointOfSaleId: 6585,
            paymentType: 1,
            languageId: selectedLanguageId
        };

        await axios
            .post(`${baseUrl}/ShopBasket/Order`, startOrderBody)
            .then((result) => {
                setOrderIdParameter(result.data.id);
                loadEvent(selectedEventId, result.data.id);
                requestSeatmapAndZones();
            })
            .catch((error) => console.error(error.response.data));
    }

    const requestSeatmapAndZones = async () => {

        var seatmap = await getSeatMapById(selectedSeatmapId);
        setSeatmap(seatmap);

        var zones = await getZonesBySeatMapId(selectedSeatmapId);
        setZones(zones);

        /* if (zones?.length === 1) {*/
        setSelectedZone(zones[0]);
        /* / }*/
    };

    const applyPromotion = async () => {
        setPromotionCodeMessage("");
        const order = await applyPromotionCodeToOrder(orderIdParameter, promotionCode);
        setUnlockedTicketTypes(order.unlockedTicketTypes);
        setIsPromotionCodeAdded(true);
        //loadEvent(selectedEventId, orderIdParameter);
    }

    const applyPromotionCodeToOrder = async (orderId, code) => {
        try {
            const response = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${code}`);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionCodeMessage(resources.detailPage?.errorMessage);
        }
    }

    const loadEvent = async (eventId, orderId) => {

        if (eventId === 0 || orderId === 0) {
            return;
        }

        try {

            //event
            const event = await getEventById(eventId);
            const infos = await getEventInfosByEventId(eventId);

            // setting the eventInfo object in the info attribute of event
            const updatedEventInfo = { ...event, info: infos };

            const ticketTypes = await getTicketTypesByEventId(eventId);
            const updatedTicketTypes = await Promise.all(
                ticketTypes.map(async (ticketType) => {
                    const info = await getTicketTypeInfosByTicketTypeId(ticketType.id);

                    // sorting it according to the language
                    let ticketTypeInfo;

                    if (info.some(entry => entry.languageId === 3)) {
                        // Keep only entries with languageId 3
                        ticketTypeInfo = info.filter(entry => entry.languageId === selectedLanguageId);
                    } else {
                        // Keep only entries with languageId 0
                        ticketTypeInfo = info.filter(entry => entry.languageId === 0);
                    }

                    var unlockpromotionCode = "";

                    if (isPromotionCodeAdded) {
                        if (unlockedTicketTypes?.includes(ticketType.id)) {
                            unlockpromotionCode = promotionCode
                        }
                    }

                    const ticketTypeAvailability = unlockpromotionCode != "" ?
                        await getTicketTypeNumberOfAvailableTickets(ticketType.id, orderId, unlockpromotionCode) :
                        await getTicketTypeNumberOfAvailableTickets(ticketType.id, orderId);

                    const ticketTypePrice = await getTicketTypePriceForOrder(orderId, ticketType.id);

                    // setting the ticketTypeInfo and ticketTypeAvailability object as attributes in ticketType (info and availability)
                    return { ...ticketType, info: ticketTypeInfo, availability: ticketTypeAvailability, updatedPrice: ticketTypePrice }
                })
            )

            if (!updatedTicketTypes || updatedTicketTypes.length === 0
                || !(updatedTicketTypes.some(tt => tt.availability?.availableTickets > 0 && tt.availability?.status === 0))) {
                setIsTicketsAvailable(false);
            }
            else {
                setIsTicketsAvailable(true);
            }

            setEvent(updatedEventInfo);
            setTicketTypes(updatedTicketTypes);
            setLoading(false);

        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    }

    const eventInfoDiv = () => {
        const eventInfo = event.info?.eventInfos?.find((i) => i.languageId == selectedLanguageId) ?? event.info?.eventInfos?.find((i) => i.languageId == 0);

        return (
            <div className="row mb-4">
                <div className="col-12">
                    {(eventInfo?.bannerImagePath?.length > 0 && showEventBanner == "true") &&
                        <img className="img-fluid mb-4" src={eventInfo?.bannerImagePath} width="100%"></img>}
                    <p className="ticketinoText text titleStyle text-start text-right fs-3 fw-semibold mb-2 text-break text-start">{eventInfo?.name}</p>
                    <p className="ticketinoText text fs-6 text-right text-break text-start">{eventInfo?.shortDescription}</p>
                </div>
            </div>
        )
    }


    const languageSelectDiv = () => {
        return (
            <div className="container">
                <div className="row justify-content-end">
                    <div className="col-auto g-0">
                        <select
                            className="ticketinoSelect form-select"
                            aria-label=""
                            value={selectedLanguage}
                            onChange={(e) => {
                                updateLanguage(e.currentTarget.value);
                            }}
                        >
                            <option value={"en"} key={1} >{"en"}</option>
                            <option value={"de"} key={2} >{"de"}</option>
                            <option value={"fr"} key={3} >{"fr"}</option>
                            <option value={"it"} key={4} >{"it"}</option>
                        </select>
                    </div>
                </div>
            </div>
        )
    }

    const promotionCodeDiv = () => {
        return (
            <div className="mb-4 row mt-2">
                <div className="col-9">
                    <input
                        type="text"
                        name="firstname"
                        className="ticketinoInput form-control inputCodeFirstname"
                        placeholder={resources.detailPage?.labelPromotioncode}
                        id="inputCode"
                        onChange={(event) => setPromotionCode(event.currentTarget.value)}
                    />
                </div>
                <button className="ticketinoButton btn button btn-light col-3" disabled={promotionCode == ""} onClick={applyPromotion}>{resources.detailPage?.buttonLabelUseCode}</button>
                <div className="ticketinoText text fs-6 text-start ticketinoError mt-2">
                    {promotionCodeMessage}
                </div>
                <div className="ticketinoText text fs-6 text-start ticketinoError mt-2">
                    {errorMessage}
                </div>
            </div>
        )
    }
    const handleRemoveSeat = (seatId) => {

        let selectedSeatList = selectedSeats.filter(seat => seat.id !== seatId);

        setSelectedSeats(selectedSeatList);
    };

    const selectTicketTypeForSeat = (seatId, ticketTypeId) => {
        const updatedSeats = selectedSeats.map(seat => {

            if (seat.id === seatId) {
                return { ...seat, selectedTicketTypeId: ticketTypeId };
            }
            return seat;
        });

        setSelectedSeats(updatedSeats); // Assuming you're using useState

    }

    const addTicketsToBasket = async () => {
        let canContinue = true;
        let ticketstoAdd = [];

        if (selectedSeats.length === 0) {
            return;
        }

        if (selectedSeats.some(selectedSeat => selectedSeat.selectedTicketTypeId === null || selectedSeat.selectedTicketTypeId === 0 || !('selectedTicketTypeId' in selectedSeat))) {
            setErrorMessage(resources.ticketPage?.PleaseSelectTicketTypeForAllSeats);
            canContinue = false;
        }

        ticketstoAdd = selectedSeats.map((selectedSeat) => {
            return {
                ticketTypeId: selectedSeat.selectedTicketTypeId,
                seatId: selectedSeat.id,
                quantity: 1,
                zoneId: selectedSeat.ZoneId,
            };
        });

        if (isPromotionCodeAdded) {

            ticketstoAdd.map((tickettoAdd) => {
                if (unlockedTicketTypes?.includes(tickettoAdd.selectedTicketTypeId)) {
                    tickettoAdd.promotionCode = promotionCode
                }
            });
        }


        if (canContinue) {
            const order = await addTicketsToShopBasket(orderIdParameter, ticketstoAdd);

            if (order) {
                props.changeTicketTypesInformation(ticketTypes);
                props.changeOrderId(order.id);
                props.changePage(1);
            }
        }
    }

    const addTicketsToShopBasket = async (orderId, ticketsToAdd) => {

        try {
            const response = await axios.post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, { ticketstoAdd: ticketsToAdd });
            return response.data;
        } catch (error) {
            if (error.response?.status === 403) {
                setErrorMessage(error.response.data)
            }
            else {
                setErrorMessage(resources.ticketPage?.generalErrorMessage)
            }
        }
    }


    const selectedSeatsDiv = () => {
        return (<div>
            {selectedSeats.map((seat, index) => (
                <div className="mb-3" key={seat.id}>
                    <div className="row align-items-start">
                        <div className="col-10">
                            <div className="list-group-item ms-1">
                                {resources.ticketPage?.Zone}: {seat.zoneName}, {resources.ticketPage?.Row}: {seat.rowName}
                            </div>
                        </div>
                        <div className="col-2 text-end">
                            <button
                                type="button"
                                className="btn-close me-1"
                                aria-label="Close"
                                onClick={() => handleRemoveSeat(seat.id)}
                            ></button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col ms-1 me-1">
                            <div key={seat.id} className="list-group-item">
                                {resources.ticketPage?.Seat}: {seat.seatName}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col ms-1 me-1">
                            <select
                                className="ticketinoSelect form-select"
                                aria-label=""
                                value={seat.selectedTicketTypeId}
                                onChange={(e) => {
                                    const selectedTicketTypeId = e.currentTarget.value;
                                    selectTicketTypeForSeat(seat.id, selectedTicketTypeId);
                                }}
                            >
                                <option value={null} key="default" id={null}>
                                    {resources.ticketPage?.SelectCategory}
                                </option>

                                {seat.seatTicketTypes.map(tt => (
                                    <option key={tt.id} value={tt.id}>
                                        {tt.info?.[0]?.name || "No name"}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {/* White horizontal line between entries */}
                    {index !== selectedSeats.length - 1 && (
                        <hr style={{ borderBottom: "1px solid white", margin: "1rem 0" }} />
                    )}
                </div>
            ))}
        </div>);
    }

    //-----HTML Display------
    return (
        <div className="page-container container-fluid px-3">
            {languageSelectDiv()}
            {loading ? <Loading /> :
                <div className="container">
                    {eventInfoDiv()}
                    {(allowUnlockTicketTypes === "true") && promotionCodeDiv()}
                    {(allowUnlockTicketTypes === "true") && isPromotionCodeAdded && unlockedTicketTypes?.length > 0 &&
                        <div class="alert alert-success p-2 mb-3" role="alert" >
                            {resources.ticketPage?.PromotionCodeApplied}
                        </div>}
                    {selectedZone && Object.keys(selectedZone).length > 0 && selectedZone.id > 0 &&
                        <div className="row mb-4">
                            <div className={`${selectedSeats.length > 0 ? 'col-9' : 'col-12'} p-0`}>
                                <Zone
                                    eventId={selectedEventId}
                                    zoneId={selectedZone.id}
                                    changeLanguage={changeLanguage}
                                    languageISO={selectedLanguage}
                                    selectedCurrency={currency}
                                    ticketTypes={ticketTypes}
                                    token={token}
                                    selectedSeatIds={selectedSeats.length > 0 ? selectedSeats.map(seat => seat.id) : []}
                                    onSeatClick={onSeatClick}
                                />
                            </div>
                            {/* shop basket panel */}
                            {selectedSeats.length > 0 &&
                                <div className="col-3 bg-light p-0">
                                    {selectedSeatsDiv()}
                                </div>}
                        </div>}
                    {selectedEventGroupId > 0 && <button className="button btn-grey btn-ticketino-large mb-3" onClick={() => props.changePage(-1)} >
                        {resources.customerPage?.buttonLabelPrevious}
                    </button>}
                    {isTicketsAvailable && <button className="button btn-orange btn-ticketino-large float-end mb-4" disabled={!(selectedSeats.length > 0) || selectedSeats.some(seat => seat.selectedTicketTypeId === null || seat.selectedTicketTypeId === "" || seat.selectedTicketTypeId === 0 || !('selectedTicketTypeId' in seat))} onClick={addTicketsToBasket}>
                        {resources.ticketPage?.buttonLabelContinue}
                    </button>}
                </div>}
        </div>
    )

}

export default SeatmapTicketSelect;